import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AgentStateQueryVariables = Types.Exact<{
  groupId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  interval?: Types.InputMaybe<Types.StateChangeTimeInterval>;
}>;


export type AgentStateQuery = { __typename?: 'Query', agentStateChanges?: { __typename?: 'ListOfChanges', changes: Array<{ __typename?: 'StateChange', agentNumberId: number, timeOfChange: any, oldState: Types.AgentState, state: Types.AgentState }> } | null };


export const AgentStateDocument = gql`
    query AgentState($groupId: Int, $interval: StateChangeTimeInterval) {
  agentStateChanges(groupId: $groupId, interval: $interval) {
    changes {
      agentNumberId
      timeOfChange
      oldState
      state
    }
  }
}
    `;

/**
 * __useAgentStateQuery__
 *
 * To run a query within a React component, call `useAgentStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentStateQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useAgentStateQuery(baseOptions?: Apollo.QueryHookOptions<AgentStateQuery, AgentStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentStateQuery, AgentStateQueryVariables>(AgentStateDocument, options);
      }
export function useAgentStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentStateQuery, AgentStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentStateQuery, AgentStateQueryVariables>(AgentStateDocument, options);
        }
export function useAgentStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentStateQuery, AgentStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentStateQuery, AgentStateQueryVariables>(AgentStateDocument, options);
        }
export type AgentStateQueryHookResult = ReturnType<typeof useAgentStateQuery>;
export type AgentStateLazyQueryHookResult = ReturnType<typeof useAgentStateLazyQuery>;
export type AgentStateSuspenseQueryHookResult = ReturnType<typeof useAgentStateSuspenseQuery>;
export type AgentStateQueryResult = Apollo.QueryResult<AgentStateQuery, AgentStateQueryVariables>;